export default "__VITE_ASSET__kY5f5hqU__"